import React from "react";
const CIATEEQuestionPaperReportCourseWise = () => {
  return (
    <>
      <h1>Hello from CIA, TEE Question Paper Report Course-wise</h1>
    </>
  );
};

export default CIATEEQuestionPaperReportCourseWise;
